export const NOTICE_ERROR_500_TITLE = 'На сайте проводятся технические работы'
export const NOTICE_ERROR_500_CONTENT = 'Попробуйте обновить страницу немного позднее.'
export const NOTICE_ERROR_403_TITLE = 'Доступ запрещен'
export const NOTICE_ERROR_403_CONTENT = 'У вас недостаточно прав для выполнения данного действия.'
// сетевые ошибки
export const NOTICE_NETWORK_ERROR_TITLE = 'Ошибка сети'
export const NOTICE_NETWORK_ERROR_CONTENT =
  'Проверьте соединение с интернетом, отключите VPN и попробуйте снова.'
// ошибки парсинга данных (сервер ответил фигней)
export const NOTICE_DATA_ERROR_TITLE = 'Ошибка данных'
export const NOTICE_DATA_ERROR_CONTENT = 'Сервер прислал некорректный ответ.'
